import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ExpenseDataBuilder } from './expense-data.builder';
import { ExpenseDataService } from './expense-data.service';
import { ExpenseDataEffects } from './expense-data.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './expense-data.reducer';
import { ExpenseDataDispatcher } from './expense-data.dispatcher';
import { ExpenseDataStore } from './expense-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([ExpenseDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class ExpenseDataModule {
  static forRoot(): ModuleWithProviders<ExpenseDataModule> {
    return {
      ngModule: ExpenseDataModule,
      providers: [
        ExpenseDataDispatcher,
        ExpenseDataService,
        ExpenseDataStore,
        ExpenseDataBuilder,
      ],
    };
  }
}
